export default __webpack_public_path__ + "static/logo-519b11fb459db6a815111e6d9738257e.svg";